import React from "react";
import SourceCard from "../../SourceCard";
import CommentCard from "../../CommentCard";
import ScrollContainer from "react-indiana-drag-scroll";

function PostAndCommentsModule({ clusterData }) {
  console.log("cluster data in post and comments: ", clusterData);
  return (
    <div
      id="posts-and-comments"
      className="col-span-3 space-y-6 rounded-md p-4 shadow-socialglass"
    >
      <div id="posts" className="">
        <div className="flex items-center gap-x-2">
          <h2 className="text-left text-xl font-bold">Related Posts</h2>
          <h2 className="text-xl italic text-gray-400">
            (
            {clusterData?.relatedPosts.length > 1
              ? clusterData?.relatedPosts.length
              : "1"}{" "}
            featured )
          </h2>
        </div>

        <h3 className="text-left text-lg text-gray-400"> </h3>
        <ScrollContainer
          horizontal={true}
          className="flex w-full space-x-4 overflow-x-scroll [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        >
          {clusterData?.relatedPosts.map((post, i) => (
            <SourceCard key={i} post={post} />
          ))}
        </ScrollContainer>
      </div>

      <div id="comments" className="w-full">
        <h2 className="text-left text-xl font-bold">Additional Comments</h2>
        <ScrollContainer
          vertical={true}
          className="flex h-96 w-full flex-col space-y-6 overflow-y-scroll [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        >
          {clusterData.additionalComments?.map((comment, commentIndex) => (
            <CommentCard
              key={`comment-${commentIndex}`}
              comment={comment}
              hasHeart={true}
            />
          ))}
        </ScrollContainer>
      </div>
    </div>
  );
}

export default PostAndCommentsModule;
